import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_94e8mnvjlr: FaireBrandEntity = {
  token: "b_94e8mnvjlr",
  type: "brand",
  name: "Curated Basics",
  avatarUrl:
    "https://cdn.faire.com/fastly/3c43611ff746110d2fb17ce7de8b14daa4b9cbb4561ee89e3e6230b914a9fa19.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f1707e6e24dc78fc756b00d0426a70477a19455b0eba64f974c7b5ea7a1c273b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3c43611ff746110d2fb17ce7de8b14daa4b9cbb4561ee89e3e6230b914a9fa19.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f1707e6e24dc78fc756b00d0426a70477a19455b0eba64f974c7b5ea7a1c273b.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 60,
  isTopShop: true,
  isInsider: true,
  description:
    "Curated Basics is a NYC-based accessories company. We independently design, and work directly with factory to produce our small batch products including leather goods, bags, small everyday objects, and jewelry. Simple, and good quality accessories with a flair. Giving back to our community is an essential part of our identity. To date, we’ve donated over 10,000 pairs of socks and boxers to Bowery Mission, The Father's Heart Ministries in New York, Housing Works and Hoboken Homeless Shelter in Hoboken, NJ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:57.690Z",
    importedBy: "entity-db-cli",
  },
};
